<template>
	<AppHeader />
</template>

<script>
import AppHeader from "@/components/Header/AppHeader.vue";

export default {
	name: "Header",
	components: {
		AppHeader
	}
};
</script>

<style scoped>
</style>